module.exports = __webpack_public_path__ + "static/media/main.5d1e75a4.png";